/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-len */
import React from 'react'
import { Alert } from 'react-bootstrap'
import { ApplicationModel } from '../../../../models/ApplicationModel'
// import { ConsolidatedGrantHistoryModel } from '../../../../models/ConsolidatedGrantHistory' TODO: NOT USED, REMOVE
import { Label } from '../../../../shared/fields'
import { formatNumber } from '../../../../shared/Utility'
import { GRANT_GUIDELINES_URL } from '../..'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    preview?: boolean
}

export interface State {

}

export default class PriorGrants extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {

    }
  }

  render() {
    const { model, preview } = this.props
    const hasGrantHistory = model.consolidatedGrantHistory?.totalNumberOfGrants > 0
    const totalNoOfGrants = model.consolidatedGrantHistory?.totalNumberOfGrants
    const noGrantHistory = 'No search results returned.'
    const grantHistory = () => (
      <table className="table table-sm mt-3">
        <thead>
          <tr>
            <th style={{ width: '15%' }}>Grant year</th>
            <th style={{ width: '25%' }}>Grant Program Round</th>
            <th style={{ width: '30%' }}>Amount (AUD$)</th>
            <th style={{ width: '30%' }}>Tier</th>
          </tr>
        </thead>
        <tbody>
          {model.consolidatedGrantHistory.emdgPastGrants.map((gh, i) => (
            <tr key={`${i}gh`}>
              <td>{gh.grantYearName}</td>
              <td>{gh.grantProgramRound}</td>
              <td>
                {`$ ${formatNumber(gh.paymentRequestAmount)}`}
              </td>
              <td>{gh.grantAgreementCategory}</td>
            </tr>
          ))}
        </tbody>
        <tfoot className="table-summary-top table-summary-bottom">
          <tr>
            <th>Total:</th>
            <th>&nbsp;</th>
            <th>{`$ ${formatNumber(model.consolidatedGrantHistory.totalGrantsAmount)}`}</th>
          </tr>
        </tfoot>
      </table>
    )

    return (
      <div className="form-item">
        {hasGrantHistory ? grantHistory() : null}
        <Label
          label={hasGrantHistory
            ? (
              <>
                <strong>Total number of grants already received:</strong>
                {' '}
                {totalNoOfGrants}
              </>
            )
            : noGrantHistory}
          preview={preview}
        />
        <Alert className="emdg-page-alerts">
          <strong>Disclaimer:</strong>
          <br />
          {' '}
          This is a direct search from the Austrade system. The details will only display grants paid from 1 July 1990 to
          the same Australian Business Number (ABN). The information will not reflect any amounts that you may have
          been asked to repay or if your business is subject to organisational restructuring as per the EMDG Act and
          Rules.
          <br />
          {' '}
          <br />
          Please check your EMDG grant history to ensure it is accurate prior to submitting your grant application.
          Should you have any questions about your grants history please contact us at
          {' '}
          <a href="mailto:EMDG.Help@austrade.gov.au">EMDG.Help@austrade.gov.au</a>
          {' '}
          or on 13 28 78.
          <br />
          {' '}
          <br />
          While SME applicants can receive EMDG for up to 8 financial years, amendments to the rules introduce a
          change to the method of calculating eligible grant years.
          <br />
          {' '}
          <br />
          From Round 4 grant years will be calculated based on a business entering into a grant agreement, rather
          than on grants paid. See section 4.1.1.5-6 of the
          {' '}
          <a href={`${GRANT_GUIDELINES_URL}`} target="_blank" rel="noreferrer">Grant Guidelines</a>
          {' '}
          for further information.
        </Alert>
      </div>
    )
  }
}
